'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var XHR2 = require('xhr2');

var Method;

(function (Method) {
  Method[Method["GET"] = 0] = "GET";
  Method[Method["POST"] = 1] = "POST";
})(Method = exports.Method || (exports.Method = {}));

var post = function post(url, body) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return request(Method.POST, url, body, timeout);
};

var get = function get(url) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return request(Method.GET, url, null, timeout);
};

exports.HTTP = {
  get: get,
  post: post
};

var request = function request(method, url, body, timeout) {
  return new Promise(function (resolve, reject) {
    var xhr = new XHR2();
    xhr.timeout = timeout;
    xhr.open(Method[method], url);

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        var res = {
          Code: xhr.status,
          Body: null
        };

        if (xhr.status === 200) {
          try {
            res.Body = JSON.parse(xhr.responseText);
          } catch (e) {
            return reject(new Error("[thor-provider]Error parsing the response: ".concat(e.message)));
          }
        } else if (xhr.responseText && xhr.responseText.length) {
          res.Body = xhr.responseText;
        }

        return resolve(res);
      }
    };

    xhr.ontimeout = function () {
      return reject(new Error("[thor-provider]Time out for whatever reason, check your provider"));
    };

    try {
      xhr.send(method === Method.POST ? JSON.stringify(body) : null);
    } catch (e) {
      return reject(new Error("[thor-provider]Connect error: ".concat(e.message)));
    }
  });
};